import { useParams } from "react-router-dom";
import PropertyDetailsPage from "@/components/PropertyDetailsPage";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PropertyDetailsPageRoute = () => {
  const { id } = useParams();

  return (
    <div className="bg-brand-canvas min-h-screen">
      <Header />
      <PropertyDetailsPage propertyId={id} />
      <Footer />
    </div>
  );
};

export default PropertyDetailsPageRoute;
